ACC.recentlyviewedproducts = {
  mainClass: '.ph-recentlyviewed-products',
  bindAll: function(isAjaxRequired) {
    var isHhs = $(document).find('.ph-ishhs').text(),
        showPrice = $('.ph-showprice').val(),
        ctnlist = [],
        prodList = [],
        url = ACC.config.contextPath.concat('/lazyload/gethhspricedata'),
        contentType = 'application/x-www-form-urlencoded',
        dataObj = {},
        cardItem = 'ph-card-item',
        isOneStore = $('.ph-isOneStore').html();

    if ($(window).width() > 600) {
      ACC.recentlyviewedproducts.cardsCarousel();
    } else {
      var cardWidth = $('.ph-recentlyviewed-products__jcarousel').innerWidth() / 2;

      $(ACC.recentlyviewedproducts.mainClass).find('li').css('width', cardWidth + 'px');
    }

    ACC.recentlyviewedproducts.activePage();
    ACC.recentlyviewedproducts.resizeAll();

    if (isAjaxRequired) {
      if (isHhs === 'true' || isOneStore === 'true') {
        $('.ph-recentlyviewed-products > li').each(function() {
          ctnlist.push($(this).find('.' + cardItem).attr('data-ctn'));
        });
        dataObj = {
          codes: ctnlist.toString()
        };

        if (isOneStore === 'true') {
          url = ACC.config.contextPath.concat('/lazyload/getPriceList');
          $('.ph-recentlyviewed-products > li').each(function() {
            var currObj = {
              salesOrg: ''
            };

            currObj.salesOrg = $(this).find('.' + cardItem).attr('data-salesorg');
            currObj.code = $(this).find('.' + cardItem).attr('data-ctn');
            prodList.push(currObj);
          });
          contentType = 'application/json';
          dataObj = {
            productList: prodList
          };
          dataObj = JSON.stringify(dataObj);
        }

        if (String(showPrice) === 'true') {
          ACC.recentlyviewedproducts.priceAjaxCall(url, dataObj, isHhs, contentType);
        }
      } else {
        ACC.recentlyviewedproducts.forRegularStore(url, dataObj, isHhs, contentType);
      }
    }
  },
  forRegularStore: function() {
    var url = ACC.config.contextPath.concat('/lazyload/getpricedata'),
        contentType = 'application/x-www-form-urlencoded',
        isHhs = 'false';

    $(ACC.recentlyviewedproducts.mainClass).find('.ph-card-item').each(function() {
      var ctnlist = $(this).attr('data-ctn'),
          isSpProduct = $(this).find('.ph-product-isSpProduct').val(),
          dataObj = {
            code: ctnlist,
            isSparePart: isSpProduct
          };

      ACC.recentlyviewedproducts.priceAjaxCall(url, dataObj, isHhs, contentType);
    });
  },
  resizeAll: function() {
    var productContent = '',
        productContentHeight = 0,
        productPrice = '',
        productPriceHeight = 0,
        $listItems = $(ACC.recentlyviewedproducts.mainClass).find('li');

    $listItems.each(function() {
      productContent = $(this).find('.ph-card-product-details');
      productPrice = $(this).find('.ph-recently-product-price');

      if (productContentHeight < productContent.outerHeight()) {
        productContentHeight = productContent.outerHeight();
      }

      if (productPriceHeight < productPrice.outerHeight()) {
        productPriceHeight = productPrice.outerHeight();
      }
    });

    $listItems.find('.ph-card-product-details').height(productContentHeight);
    $listItems.find('.ph-recently-product-price').height(productPriceHeight);
  },
  cardsCarousel: function() {
    var $jcarousel = $('.ph-recentlyviewed-products__jcarousel');

    $jcarousel.on('jcarousel:reload jcarousel:create', function() {
      var $carousel = $(this),
          width = $carousel.innerWidth();

      if (width >= 768) {
        width = width / 4;
      } else if (width < 768) {
        width = width / 3;
      }

      $carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
    }).jcarousel({
      wrap: null
    }).jcarouselSwipe({
      perSwipe: 1
    });

    $('.ph-recentlyviewed-products__prevarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass('ph-inactive');
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass('ph-inactive');
    }).jcarouselControl({
      target: '-=1'
    });

    $('.ph-recentlyviewed-products__nextarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass('ph-inactive');
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass('ph-inactive');
    }).jcarouselControl({
      target: '+=1'
    });
    // Carousel pagination
    $('.ph-jcarousel-pagination').jcarouselPagination({
      perPage: 3,
      item: function(page) {
        return '<a href="#' + page + '"><span class="ph-jcarousel-pagination-dot" data-page="' + page + '"></span></a>';
      }
    });

    $jcarousel.on('jcarousel:animateend', function() {
      ACC.recentlyviewedproducts.activePage();
    });
  },
  activePage: function() {
    var pageNumber = 1;
    var navigationList = $('.ph-jcarousel-pagination').find('a');
    var completeUrl = window.location.href;

    if (completeUrl.indexOf('#') !== -1) {
      pageNumber = completeUrl.split('#').splice(1, 1).join();
    }

    navigationList.each(function() {
      $(this).find('span').removeClass('ph-active-page');

      if (('#' + pageNumber) === $(this).attr('href')) {
        $(this).find('span').addClass('ph-active-page');
      }
    });
  },
  priceAjaxCall: function(urlText, dataObj, isHhs, contentType) {
    var isOneStore = $('.ph-isOneStore').html();

    $.ajax({
      type: 'POST',
      url: urlText,
      contentType: contentType,
      dataType: 'json',
      data: dataObj,
      success: function(result) {
        if (result) {
          if (isHhs === 'true' || isOneStore === 'true') {
            result.forEach(function(productData) {
              ACC.recentlyviewedproducts.lazyloadPriceData(productData, isOneStore);
            });
          } else {
            ACC.recentlyviewedproducts.lazyloadPriceData(result, isOneStore);
          }
        }
      }
    });
  },
  recentlyviewedHss: function(productData) {
    var deliveryDateValue = '',
        instockDeliveryRange = String($('.ph-hhsvar-instockDeliveryRange').text());

    if (String(productData.philipsATPData) !== 'null' && productData.price !== null) {
      if (productData.philipsATPData.estimateDeliveryDate && productData.philipsATPData.estimateDeliveryDate !== '') {
        deliveryDateValue = instockDeliveryRange + '&nbsp;&nbsp;' + productData.philipsATPData.estimateDeliveryDate;
        $('.ph-pdp_stock_deliverytime').find('.ph-atpmessage').html(deliveryDateValue);
      }
    }
  },
  priceDataCheckOSCondition: function(currentCtn, currentSalesOrg, productData, isOneStore) {
    if (isOneStore !== 'true' && productData.code === currentCtn) {
      return true;
    }

    if (isOneStore === 'true' && productData.code === currentCtn && currentSalesOrg === productData.salesOrg) {
      return true;
    }

    return false;
  },
  lazyloadPriceData: function(productData, isOneStore) {
    $(ACC.recentlyviewedproducts.mainClass).find('.ph-card-item').each(function() {
      var $thisElement = $(this),
          currentCtn = $thisElement.attr('data-ctn'),
          currentSalesOrg = $thisElement.attr('data-salesOrg'),
          product = productData,
          stockStatus = '';

      if (ACC.recentlyviewedproducts.priceDataCheckOSCondition(currentCtn, currentSalesOrg, productData, isOneStore) === true) {
        var priceData = productData.price,
            priceFree = $(document).find('.ph-free-text').text(),
            priceElement = 'ph-recently-product-price',
            priceContainer = $thisElement.find('.' + priceElement).find('s'),
            stockinfo = $thisElement.find('.ph-recently-stock-info'),
            finalpriceContainer = $thisElement.find('.' + priceElement).find('span');

        priceContainer.removeClass('hidden');

        if (priceData) {
          ACC.recentlyviewedproducts.renderPrice(priceData, priceFree, priceContainer, finalpriceContainer);
          ACC.pdp.igtdMessageDisplay(productData.code);
        }

        stockinfo.addClass('hidden');

        if (product.stock && product.stock.stockLevelStatus && product.stock.stockLevelStatus.code) {
          stockStatus = product.stock.stockLevelStatus.code;
        }

        if (stockStatus === 'outOfStock' || product.price === null || product.approval === 'regulatoryonhold') {
          stockinfo.removeClass('hidden');
        }

        ACC.recentlyviewedproducts.renderButton(productData, stockStatus, $thisElement);
      } else if (productData.code === null) {
        $thisElement.find('.ph-recently-stock-info').removeClass('hidden');
        ACC.recentlyviewedproducts.renderButton(productData, 'outOfStock', $thisElement);
      }
    });
  },
  updatePrice: function(value, formattedValue, priceFree, container) {
    if (formattedValue !== null && formattedValue !== '') {
      if ($(document).find('.isRseUser').text() === 'true') {
        container.text(formattedValue);
      } else if (value > 0) {
        container.text(formattedValue);
      } else {
        container.text(priceFree);
      }
    }
  },
  renderPrice: function(priceData, priceFree, priceContainer, finalpriceContainer) {
    ACC.recentlyviewedproducts.updatePrice(priceData.finalPrice, priceData.formattedFinalValue, priceFree, finalpriceContainer);

    if (!(priceData.formattedFinalValue !== null && priceData.formattedFinalValue !== '')) {
      ACC.recentlyviewedproducts.updatePrice(priceData.value, priceData.formattedValue, priceFree, finalpriceContainer);
      priceContainer.addClass('hidden');
    }

    ACC.recentlyviewedproducts.updatePrice(priceData.value, priceData.formattedValue, priceFree, priceContainer);
  },
  renderButton: function(philipsProductData, stockStatus, thisElement) {
    var allowAddToCart = thisElement.find('.ph-recentlyviewed-allowAddToCart').text(),
        buttonTemplate = '',
        buttonType = 'button',
        accessibilityTransAddToCart = $('.accessibilityTransAddToCart').text(),
        priceElement = 'ph-recently-product-price',
        priceContainer = thisElement.find('.' + priceElement).find('s'),
        isRseUser = $(document).find('.isRseUser').text();

    if (allowAddToCart === 'true' && philipsProductData.price && philipsProductData.price.value && stockStatus === 'inStock') {
      buttonType = 'submit';
    }

    if (!philipsProductData.strikeThroughListPrice) {
      priceContainer.addClass('hidden');
    }

    if (isRseUser === 'true') {
      buttonType = 'button';
    }

    buttonTemplate = '<button type="' + buttonType + '"  aria-label="' + accessibilityTransAddToCart + '" class="addtocartButton ph-m-0  ph-p-0  ph-orangebutton large ';
    buttonTemplate = buttonTemplate + 'ph-addtocart ph-addtocartcategory ph-icon-refreshcart ph-positive ph-float-left';

    if (buttonType === 'button' || philipsProductData.approval === 'regulatoryonhold') {
      buttonTemplate = buttonTemplate + 'out-of-stock ph-disabledbutton" disabled="true" aria-disabled="true">';
    } else {
      buttonTemplate = buttonTemplate + '">';
    }

    buttonTemplate = buttonTemplate + '</button>';

    thisElement.find('.ph-recentlyviewed__addtocarholder').append(buttonTemplate);

    ACC.recentlyviewedproducts.resizeAll();
  }
};
$(document).ready(function() {
  if ($(document).find(ACC.recentlyviewedproducts.mainClass).length > 0) {
    ACC.recentlyviewedproducts.bindAll(true);
  }
});
$(window).resize(function() {
  if ($(document).find(ACC.recentlyviewedproducts.mainClass).length > 0) {
    ACC.recentlyviewedproducts.bindAll(false);
  }
});
